import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  WebGameColumn,
  WebGameMainCont,
  WebGameColumnInner,
  BetNotificationWr,
  UnderMaintenanceWr,
  SlowConnectionWr,
  freeBetStore,
} from '@pascal/pascal-core';

import { PopupsWrapper } from '../common';
import { useDemoSwitcher } from '../../hooks';
import LeftColumn from '../common/leftColumn';
import RightColumn from '../common/rightColumn';
import { WebMainWrapper } from '../webMainWrapper';
import { GameMainTopWrapper } from '../../components/web';
import { minOdd } from '../../enums';
import colorWheelLogo from '../../assets/images/game/logo-game.png';
import playForRealPopupImgSrc from '../../assets/images/core/play-for-real-popup.png';

export const WebGameWrapper = observer(() => {
  const { demoSwitcherAdditionalFunction } = useDemoSwitcher();
  const { activeFreeBet } = freeBetStore;

  return (
    <WebGameMainCont
      hasDemoPopup
      isShowIconTag
      isShowBogLineLobby
      hasGameTypeLoading
      lobbyLogoImageSrc={colorWheelLogo}
      playForRealPopupImgSrc={playForRealPopupImgSrc}
      demoSwitcherAdditionalFunction={demoSwitcherAdditionalFunction}
    >
      <LeftColumn />
      <WebGameColumn position='center'>
        <WebGameColumnInner position='center'>
          <WebMainWrapper>
            <GameMainTopWrapper />
          </WebMainWrapper>
        </WebGameColumnInner>
        <PopupsWrapper />
        <BetNotificationWr
          translationDynamicValues={{
            value: `x${activeFreeBet.id ? activeFreeBet?.minOdd : minOdd}`,
          }}
        />
        <UnderMaintenanceWr />
        <SlowConnectionWr />
      </WebGameColumn>
      <RightColumn />
    </WebGameMainCont>
  );
});
